import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { productIdZodSchema } from "@@/shared/products/product-id";
import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";
import type { Except } from "type-fest";
import { z } from "zod";

type ChannexJobId = Branded<string, "ChannexJobId">;
const idPrefix = "channex_job__";
const {
    zodSchema: ChannexJobIdZodSchema,
    factory: ChannexJobIdFactory,
    assert: _isICalImport,
} = genericId<ChannexJobId>(idPrefix, {
    regexMatch: /(^channex_job_.*$)/,
});

// Job specific model for iCal import channel to not mix them to much with the data model

const channexJobZodObject = z.object({
    _id: ChannexJobIdZodSchema,
    _createdAt: isoAndUnixZodSchema,
    _type: z.literal("CHANNEX_JOB"),
    //providerId: providerIdZodSchema,
    productId: productIdZodSchema,
});

type ChannexJob = z.infer<typeof channexJobZodObject>;

type FactoryParams = Except<ChannexJob, "_id" | "_createdAt" | "_type">;
const channexJobFactory = (params: FactoryParams): ChannexJob => {
    return {
        ...params,
        _id: ChannexJobIdFactory(),
        _createdAt: nowIsoAndUnix(),
        _type: "CHANNEX_JOB",
    };
};

export { channexJobFactory, channexJobZodObject };
export type { ChannexJob };
